import React, { memo, useMemo } from "react"

import { useAnnouncement } from "../../hooks/useAnnouncement"

export const withAnnouncement = Component =>
  memo(({ name = "Announcement" }: any) => {
    const { items, textColor, barBGcolor, show, hide } = useAnnouncement()

    const handleHide = () => hide()
    const data = useMemo(() => {
      if(show){
        return <Component items={items} textColor={textColor} barBGcolor={barBGcolor} handleHide={handleHide} />
      } else{ 
        return null;
      }
    }, [items, textColor, barBGcolor, show])
    Component.displayName = name
    return data
  })
